export const DATA = t => ({
  cash_movements: {
    personal: [
      {
        title: t('modal:report_reference_modal.date_title'),
        description: t('modal:report_reference_modal.date_description'),
      },
      {
        title: t('modal:report_reference_modal.type_title'),
        description: t('modal:report_reference_modal.type_description'),
      },
      {
        title: t('modal:report_reference_modal.description_title'),
        description: t('modal:report_reference_modal.description_description'),
      },
      {
        title: t('modal:report_reference_modal.amount_title'),
        description: t('modal:report_reference_modal.amount_description'),
      },
      {
        title: t('modal:report_reference_modal.balance_title'),
        description: t('modal:report_reference_modal.balance_description'),
      },
    ],
    business: [
      {
        title: t('modal:report_reference_modal.date_title'),
        description: t('modal:report_reference_modal.business_date_description'),
      },
      {
        title: t('modal:report_reference_modal.type_title'),
        description: t('modal:report_reference_modal.business_type_description'),
      },
      {
        title: t('modal:report_reference_modal.description_title'),
        description: t('modal:report_reference_modal.business_description_description'),
      },
      {
        title: t('modal:report_reference_modal.amount_title'),
        description: t('modal:report_reference_modal.business_amount_description'),
      },
      {
        title: t('modal:report_reference_modal.balance_title'),
        description: t('modal:report_reference_modal.business_balance_description'),
      },
    ],
  },
  portfolio_movements: {
    personal: [
      {
        title: t('modal:report_reference_modal.claim_title'),
        description: t('modal:report_reference_modal.claim_description'),
      },
      {
        title: t('modal:report_reference_modal.sale_price_title'),
        description: t('modal:report_reference_modal.sale_price_description'),
      },
      {
        title: t('modal:report_reference_modal.fee_title'),
        description: t('modal:report_reference_modal.fee_description'),
      },
      {
        title: t('modal:report_reference_modal.net_received_title'),
        description: t('modal:report_reference_modal.net_received_description'),
      },
    ],
    business: [
      {
        title: t('modal:report_reference_modal.date_title'),
        description: t('modal:report_reference_modal.portfolio_date_description'),
      },
      {
        title: t('modal:report_reference_modal.round_title'),
        description: t('modal:report_reference_modal.round_description'),
      },
      {
        title: t('modal:report_reference_modal.opening_principal_title'),
        description: t('modal:report_reference_modal.opening_principal_description'),
      },
      {
        title: t('modal:report_reference_modal.disbursed_title'),
        description: t('modal:report_reference_modal.disbursed_description'),
      },
      {
        title: t('modal:report_reference_modal.origination_fees_title'),
        description: t('modal:report_reference_modal.origination_fees_description'),
      },
      {
        title: t('modal:report_reference_modal.net_received_title'),
        description: t('modal:report_reference_modal.round_net_received_description'),
      },
      {
        title: t('modal:report_reference_modal.principal_repaid_title'),
        description: t('modal:report_reference_modal.principal_repaid_description'),
      },
      {
        title: t('modal:report_reference_modal.interest_paid_title'),
        description: t('modal:report_reference_modal.interest_paid_description'),
      },
      {
        title: t('modal:report_reference_modal.closing_principal_title'),
        description: t('modal:report_reference_modal.closing_principal_description'),
      },
    ],
  },
});
